/* eslint-disable */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";
import * as React from 'react';
import dayjs from 'dayjs';

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from '@mui/material/TextField';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import GroupsIcon from '@mui/icons-material/Groups';
import PersonIcon from '@mui/icons-material/Person';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import { Icon, Paper } from "@mui/material";
import Stack from '@mui/material/Stack';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { toast } from "react-toastify";

function AddNewTask() {
  const [taskTitle, setTaskTitle] = useState(null);
  const [taskContent, setTaskContent] = useState(null);
  const [worker, setWorker] = useState(null);
  const [workerEmail, setWorkerEmail] = useState(null);
  const [department, setDepartment] = useState(null);
  const [performer, setPerformer] = useState('worker');
  const [workersList, setWorkersList] = useState(null);
  const [departmentsList, setDepartmentsList] = useState(null);
  const [timeToDo, setTimeToDo] = useState(null);
  const [assignedPerformer, setAssignedPerformer] = useState(null);
  const [priority, setPriority] = useState(null);
    
  const handleChangeWorker = (event) => {
    performer === 'worker' ? (setWorker(event.target.value)) : (setDepartment(event.target.value));
    performer === 'worker' ? (workersList.find(worker => {worker.user_id === event.target.value && setWorkerEmail(worker.email)})) : setWorkerEmail(null);
    setAssignedPerformer(event.target.value);
  };

  const handleChangePriority = (event) => {
    setPriority(event.target.value);
  };

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    // setSelectedFiles(files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...files]);
  };

  const HiddenFileInput = ({ onChange }) => {
    return (
      <input
        type="file"
        multiple
        style={{ display: "none" }}
        onChange={onChange}
      />
    );
  };

  useEffect(() => {
    getAllUsers();
    getAllDepartments();
  }, []);

  const getAllUsers = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllUsers");
      const data = await response.json();
      setWorkersList(data);
      // return data;
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera WorkersList:", error);
      // return [];
    }
  };

  const getAllDepartments = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllDepartments");
      const data = await response.json();
      setDepartmentsList(data);
      // return data;
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera WorkersList:", error);
      // return [];
    }
  };



  useEffect(() => {
    console.log("----------------------");
    console.log("get workersList:", workersList);
    console.log("get departmentsList:", departmentsList);
    console.log("set taskTitle:", taskTitle);
    console.log("set taskContent:", taskContent+typeof(taskContent));
    console.log("set timeToDo: "+timeToDo+" typ timeToDo: "+typeof(timeToDo));
    console.log("set worker: "+worker);
    console.log("set workerEmail: "+workerEmail);
    console.log("set department: "+department);
    console.log("set performer: "+performer);
    console.log("set assignedPerformer: "+assignedPerformer);
    console.log("set priority: "+priority+" "+typeof(priority));
    console.log("set selectedFiles:", selectedFiles);
    console.log("----------------------");
  }, [worker, workerEmail, department, performer, selectedFiles, timeToDo, workersList, assignedPerformer, departmentsList, priority, taskContent, taskTitle]);

  useEffect(() => {
    if(performer === "department" && departmentsList !== null){
      let depCountInfo = departmentsList.find(dep => dep.id === assignedPerformer);
      if(depCountInfo !== undefined){
        if(depCountInfo.employee_count === 0){
          toast.info("W wybranym dziale " + depCountInfo.name + " nie ma jeszcze pracowników");
        } 
      } 
      console.log("depCountInfo:");
      console.log(depCountInfo);
      // toast.info("W wybranym dziale nie ma pracowników");
    }
  }, [performer, assignedPerformer]);


  const [successSB, setSuccessSB] = useState(false);
  const [infoSB, setInfoSB] = useState(false);
  const [warningSB, setWarningSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openInfoSB = () => setInfoSB(true);
  const closeInfoSB = () => setInfoSB(false);
  const openWarningSB = () => setWarningSB(true);
  const closeWarningSB = () => setWarningSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const alertContent = (name) => (
    <MDTypography variant="body2" color="white">
      Masz nowe zadanie.{" "}
      <MDTypography component="a" href="#" variant="body2" fontWeight="medium" color="white">
        {name}
      </MDTypography>
      {/* . Give it a click if you like. */}
    </MDTypography>
  );

  const renderSuccessSB = (
    <MDSnackbar
      color="success"
      icon="check"
      title="Material Dashboard"
      content="Hello, world! This is a notification message"
      dateTime="11 mins ago"
      open={successSB}
      onClose={closeSuccessSB}
      close={closeSuccessSB}
      bgWhite
    />
  );

  const renderInfoSB = (
    <MDSnackbar
      icon="notifications"
      title="Material Dashboard"
      content="Hello, world! This is a notification message"
      dateTime="11 mins ago"
      open={infoSB}
      onClose={closeInfoSB}
      close={closeInfoSB}
    />
  );

  const renderWarningSB = (
    <MDSnackbar
      color="warning"
      icon="star"
      title="Material Dashboard"
      content="Hello, world! This is a notification message"
      dateTime="11 mins ago"
      open={warningSB}
      onClose={closeWarningSB}
      close={closeWarningSB}
      bgWhite
    />
  );

  const renderErrorSB = (
    <MDSnackbar
      color="error"
      icon="warning"
      title="Material Dashboard"
      content="Hello, world! This is a notification message"
      dateTime="11 mins ago"
      open={errorSB}
      onClose={closeErrorSB}
      close={closeErrorSB}
      bgWhite
    />
  );

  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const MaterialUISwitch = styled(Switch)(({ theme }) => ({
    width: 62,
    height: 34,
    padding: 9,
    '& .MuiSwitch-switchBase': {
      margin: 0,
      padding: 0,
      transform: 'translateX(-5px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(25px)',
        '& .MuiSwitch-thumb:before': {
          backgroundImage: 
          `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="30" viewBox="0 1 20 20"><path fill="${encodeURIComponent(
            '#fff',
          )}" d="M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91zM4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"/></svg>')`,
        },
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
      width: 32,
      height: 32,
      marginLeft: '5px', // Dodałem odstęp od lewej strony
      '&::before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 1,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage:
        `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="15" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>')`,
      },
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      borderRadius: 20 / 2,
      width: 42, // Zwiększ szerokość paska
    },
  }));


  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleDeleteClick = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleSwitchChange = () => {
    setPerformer((prevPerformer) =>
      prevPerformer === "worker" ? "department" : "worker"
    );
    setAssignedPerformer(performer === "worker" ? department : worker);
  };

  
  // Funkcje obsługi zdarzeń onChange dla pól tekstowych
  const handleTitleChange = (event) => {
    setTaskTitle(event.target.value); // Aktualizuj stan komponentu z tytułem zadania
  };

  const handleContentChange = (event) => {
    setTaskContent(event.target.value); // Aktualizuj stan komponentu z treścią zadania
  };

  const handleTimeToDoChange = (newDate) => {
    setTimeToDo(newDate ? dayjs(newDate).format('YYYY-MM-DD HH:mm:ss') : null); // Aktualizuj stan komponentu z wybraną datą
  };

  const [formData, setFormData] = useState({
    // title: taskTitle,
    // content: taskContent,
    // timeToDo: timeToDo,
    // performer: performer,
    // assignedPerformer: assignedPerformer,
    // priority: priority
  });

  const handlePushTask = async () => {
    if(taskTitle !== null && taskContent !== null && taskTitle !== "" && taskContent !== "" && performer !== null && assignedPerformer !== null){
      const formDataToSend = new FormData();
      formDataToSend.append("title", taskTitle);
      formDataToSend.append("content", taskContent);
      formDataToSend.append("time_to_do", timeToDo);
      formDataToSend.append("performer", performer);
      formDataToSend.append("assigned_performer_id", assignedPerformer);
      formDataToSend.append("worker_email", workerEmail);
      formDataToSend.append("priority", priority);
      selectedFiles.forEach((file) => {
        formDataToSend.append("files[]", file);
      });

      try {
        const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/addNewTask", {
          method: "POST",
          body: formDataToSend,
        });

        const data = await response.json();
        
        if (response.ok) {
          // Wysłano pomyślnie - obsłuż odpowiedź serwera
          console.log("Żądanie zostało wysłane pomyślnie. Serwer message:", data.message);
          toast.success(`${data.message}`);

          setTaskTitle("");
          setTaskContent("");
          setPriority(null);
          setTimeToDo(null);

        } else {
          console.error("Błąd podczas wysyłania danych.");
          toast.error(`Błąd podczas wysyłania danych.`);
        }
      } catch (error) {
        console.error("Błąd podczas wysyłania żądania:", error);
        toast.error(`Błąd podczas wysyłania danych. ${error}`);
      }

    } else {
      console.log("Tytuł, treść zadania, przydzielona jednostka muszą być wypełnione.");
      toast.warning("Tytuł, treść zadania, przydzielona jednostka muszą być wypełnione.");
    }
    
  };

  

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <Card>
              {/* <MDBox mx={2} mt={-3} px={2} py={3} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h5" color="white">Dodaj nowe zadanie</MDTypography>
              </MDBox> */}
              <Grid container spacing={2} mx={0} mt={1} px={2} py={3}>
                <Grid xs={12} sm={12} md={8} lg={8}>
                  Tytuł
                  <TextField fullWidth multiline value={taskTitle} onChange={handleTitleChange} />
                </Grid>
                <Grid xs={12} sm={12} md={4} lg={4}>
                  <br />
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      label="Czas wykonania"
                      value={timeToDo}
                      onChange={handleTimeToDoChange}
                      viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid xs={12} sm={12} md={8} lg={8}>
                  <br />Treść zadania<br/>
                  <TextField fullWidth multiline rows={4} value={taskContent} onChange={handleContentChange} />
                </Grid>
                <Grid xs={12} sm={12} md={4} lg={4}>
                  <br />Do kogo przydzielić
                  <FormControlLabel style={{marginLeft: 0}}
                    control={<MaterialUISwitch sx={{ m: 1 }}
                    // defaultChecked
                    checked={performer === "department"}
                    onChange={handleSwitchChange}
                    />}
                    label="Pracownik/Dział"
                  />
                  <FormControl fullWidth>
                    <InputLabel id="worker-label">Pracownik/Dział</InputLabel>
                    <Select
                      labelId="worker-label"
                      id="demo-simple-select"
                      variant="standard"
                      value={performer === "worker" ? (worker) : (department)}
                      label="Pracownik/Dział"
                      onChange={handleChangeWorker}
                    >
                      {(performer === "worker" && workersList !== null) ? (
                        workersList.map(worker => (
                        <MenuItem value={worker.user_id}>{worker.first_name + " " + worker.last_name}</MenuItem>
                        ))
                      ) : ( performer === "worker" && workersList === null  ? (
                        <MenuItem value={null} disabled>Brak pracowników</MenuItem>
                      ) : null )}

                      {(performer === "department" && departmentsList !== null) ? (
                        departmentsList.map(department => (
                        <MenuItem value={department.id}>
                            {department.name + " ("} <Icon fontSize="small">group</Icon> {" : " + department.employee_count + ")"}
                        </MenuItem>
                        ))
                      ) : ( performer === "departmentsList" && departmentsList === null  ? (
                        <MenuItem value={null} disabled>Brak działów</MenuItem>
                      ) : null )}

                    </Select>
                  </FormControl>
                  <br /><br />
                  <FormControl fullWidth>
                    <InputLabel id="worker-label">Priorytet</InputLabel>
                    <Select
                      labelId="Priorytet-label"
                      id="Priorytet-select"
                      variant="standard"
                      value={priority}
                      label="Priorytet"
                      onChange={handleChangePriority}
                    >
                      <MenuItem value="hight">Ważne</MenuItem>
                      <MenuItem value="normal">Zwykłe</MenuItem>
                      {/* <MenuItem value="medium">Średnia</MenuItem>
                      <MenuItem value="low">Niska</MenuItem> */}
                    </Select>
                  </FormControl>

                </Grid>

                {/* UI Dodawanie obrazka początek */}
                
                {/* <Grid xs={12} sm={12} md={12} lg={12}>
                  Dodaj obrazki<br />
                  <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
                    <Paper
                      onClick={() => document.querySelector('input[type="file"]').click()}
                      style={{ width: "100px", height: "100px", position: "relative", overflow: "hidden", backgroundSize: "cover", backgroundColor: "#F5F7F8", }}
                      elevation={3}
                    >
                      <HiddenFileInput onChange={handleFileChange} />
                      <IconButton
                        color="dark"
                        aria-label="add images"
                        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
                      >
                        <AddPhotoAlternateOutlinedIcon />
                      </IconButton>
                    </Paper> */}

                    {/* wybrane obrazki muszą być w nowym Paper */}
                    {/* {selectedFiles.map((file, index) => (
                      <Paper
                        key={index}
                        style={{
                          width: "100px",
                          height: "100px",
                          // position: "relative",
                          // overflow: "hidden",
                          // backgroundColor: "#F5F7F8",
                          backgroundColor: hoveredIndex === index ? "#CCCCCC" : "#F5F7F8",
                          margin: "0 0 0 0",  // Dodaj odstęp między Papierami
                        }}
                        elevation={5}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <img
                          src={URL.createObjectURL(file)}
                          alt={`Obrazek ${index + 1}`}
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                        
                        {hoveredIndex === index && (
                          <IconButton
                            onClick={() => handleDeleteClick(index)}
                            color="primary"
                            aria-label="delete image"
                            style={{ position: "relative", top: "-70%", right: "-30%", zIndex: 1, color:"#fff",
                            backgroundColor: "#3339", // Dostosuj kolor tła
                            borderRadius: "50%", // Zaokrągl narożniki, jeśli to odpowiednie
                            }}
                          >
                            <DeleteOutlinedIcon />
                          </IconButton>
                        )}

                      </Paper>
                    ))}
                  </Stack>
                </Grid> */}

                {/* UI Dodawanie obrazka koniec */}

              </Grid>
              
              <MDBox mx={2} mt={4} mb={2}>
                <MDButton variant="gradient" color="info" fullWidth onClick={handlePushTask}>
                  Dodaj zadanie
                </MDButton>
              </MDBox>

              {/* <MDBox pt={2} px={3}></MDBox>
              <MDBox mt={2}></MDBox> */}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNewTask;
